import { BaseAPI, } from './baseAPI';
/**
 * This is the API class used for making API calls to any other server other than MODE
 */
export class ExternalAPI extends BaseAPI {
    /**
     * There is no need to create multiple instances of ExternalAPI so we will make the constructor
     * private to prevent the dev from creating instance of this class
     */
    constructor() {
        super({
            withCredentials: false,
        });
    }
    /**
     * Return an Instance of ExternalAPI. This is what dev should be using to get an instance of ExternalAPI
     * and use it to make API call.
     */
    static getInstance() {
        return ExternalAPI.instance;
    }
    /**
     * Intercept all API requests and do something with the request before sending it to the server
     */
    onFulfilledRequest(config) {
        return config;
    }
    onRejectedRequest(error) {
        return Promise.reject(this.normalizeError(error));
    }
    /**
     * Intercept all API responses and do something with the response before passing it to the requester
     */
    onFulfilledResponse(response) {
        return response;
    }
    onRejectedResponse(error) {
        const apiError = this.normalizeError(error);
        return Promise.reject(apiError);
    }
}
// Singleton instance of ExternalAPI
ExternalAPI.instance = new ExternalAPI();
